module.exports = __webpack_public_path__ + "img/gansu.5d3c10bc.jpg";